import React, { useState, useEffect, useMemo } from "react";


const StockExcess = () => {
  const [searchDrug, setSearchDrug] = useState("");
  const [uploadingUsage, setUploadingUsage] = useState(false);
  const [showTransfers, setShowTransfers] = useState(false);   // ✅ NEW
const [transferData, setTransferData] = useState([]);     
   // ✅ NEW
   // ✅ NEW
  const [monthsAhead, setMonthsAhead] = useState(3);     // ✅ NEW
const [monthsAverage, setMonthsAverage] = useState(3); // ✅ NEW
  const [inventoryData, setInventoryData] = useState([]);
  const [usageNameMap, setUsageNameMap] = useState({});
  const [latestUsageMap, setLatestUsageMap] = useState({});

  const [onlyExcess, setOnlyExcess] = useState(false);
  const [minValue, setMinValue] = useState("");
  const [searchText, setSearchText] = useState("");
  const [expandedPicked, setExpandedPicked] = useState({});
const [expandedReceived, setExpandedReceived] = useState({});
const [neededDialog, setNeededDialog] = useState(null);

  const [selectedPharmacy, setSelectedPharmacy] = useState("");
 const [uploadFiles, setUploadFiles] = useState([]);
 const [showSearchDialog, setShowSearchDialog] = useState(false);
const [searchDrugName, setSearchDrugName] = useState("");
const [searchNhs, setSearchNhs] = useState("");
const [searchResults, setSearchResults] = useState([]);
const [searchLoading, setSearchLoading] = useState(false);
 

  const groupId = localStorage.getItem("userId");
  const members = JSON.parse(localStorage.getItem("members") || "[]");
  useEffect(() => {
  fetchTransfers();
}, []);
useEffect(() => {
  fetchUsage();
}, [monthsAverage]);
  useEffect(() => {
    fetchInventory();
    fetchUsage();
  }, []);

  // 📍 DISTANCE CALC
  const getDistance = (a, b) => {
    if (!a?.lat || !b?.lat) return 9999;

    const R = 6371;
    const dLat = (b.lat - a.lat) * Math.PI / 180;
    const dLon = (b.lng - a.lng) * Math.PI / 180;

    const lat1 = a.lat * Math.PI / 180;
    const lat2 = b.lat * Math.PI / 180;

    const aVal =
      Math.sin(dLat / 2) ** 2 +
      Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);

    return R * (2 * Math.atan2(Math.sqrt(aVal), Math.sqrt(1 - aVal)));
  };

  // 🔧 NORMALISE
  const normaliseDrug = (raw) => {
    if (!raw) return { key: "" };

    let str = raw.toLowerCase();

    const strengthMatch = str.match(/\d+\s*(mg|g|ml|mcg)/);
    const strength = strengthMatch ? strengthMatch[0].replace(/\s+/g, "") : "";

    str = str
      .replace(/\(.*?\)/g, "")
      .replace(/\d+\s*(mg|g|ml|mcg)/g, "")
      .replace(/\d+\s*(tablet|capsule)/g, "")
      .replace(/tablets?|capsules?/g, "")
      .replace(/\s+/g, " ")
      .trim();

    return { key: `${str}_${strength}` };
  };

  const formatMonth = (ym) => {
    if (!ym || ym.length !== 6) return ym;
    const year = ym.substring(0, 4);
    const month = parseInt(ym.substring(4, 6), 10) - 1;
    return new Date(year, month).toLocaleString("en-GB", {
      month: "short",
      year: "numeric"
    });
  };

  const isStale = (ym) => {
    if (!ym || ym.length !== 6) return true;
    const year = parseInt(ym.substring(0, 4), 10);
    const month = parseInt(ym.substring(4, 6), 10) - 1;
    const usageDate = new Date(year, month);
    const now = new Date();
    const diffMonths =
      (now.getFullYear() - usageDate.getFullYear()) * 12 +
      (now.getMonth() - usageDate.getMonth());
    return diffMonths > 3;
  };

  // 📦 FETCH INVENTORY
  const fetchInventory = async () => {
    const token = localStorage.getItem("authToken");

    const res = await fetch(
      `https://api.pharmacegroup.co.uk/ggetInventory?groupId=${groupId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const data = await res.json();
    setInventoryData(data);
  };

  // 📊 FETCH USAGE
  const fetchUsage = async () => {
    try {
      const token = localStorage.getItem("authToken");
const res = await fetch(
  `https://api.pharmacegroup.co.uk/getUsage3MonthsGroup?groupId=${groupId}&monthsBack=${monthsAverage}`, // ✅ MODIFIED
      
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const data = await res.json();

      const lookup = {};
      const latestMap = {};

      data.forEach(item => {
       const val = (item.avgMonthlyUsage || 0);

      const parsed = normaliseDrug(item.drugName);
const member = members.find(m => m.pharmacyId === item.pharmacyId);
const ocsCode = member?.ocsCode || item.pharmacyId;
const key = `${ocsCode}_${parsed.key}`;

lookup[key] = val;

if (item.dispensingmonth) {
  if (
    !latestMap[ocsCode] ||
    item.dispensingmonth > latestMap[ocsCode]
  ) {
    latestMap[ocsCode] = item.dispensingmonth;
  }
}
      });

      setUsageNameMap(lookup);
      setLatestUsageMap(latestMap);
    } catch (err) {
      console.log("❌ fetchUsage error:", err);
    }
  };

const pendingTransferMap = useMemo(() => {
  const map = {};

  transferData.forEach(t => {
    if (t.status !== "pending") return;

    t.items?.forEach(item => {
      const member = members.find(m => m.pharmacyId === t.fromPharmacyId);
      const ocsCode = member?.ocsCode || t.fromPharmacyId;

      const parsed = normaliseDrug(item.drug);
      const key = `${ocsCode}_${parsed.key}`;

      if (!map[key]) map[key] = 0;

    const tablets = item.qty * (item.qtval || 1);

map[key] += tablets;
    });
  });

  return map;
}, [transferData, members]);


// 🔥 DISPLAY DATA
const displayData = useMemo(() => {
  const grouped = {};

  inventoryData
    .filter(i => (i.status || "").toLowerCase().includes("shelf"))
    .forEach(item => {
      const parsed = normaliseDrug(item.vmppNm);

      const packets = parseInt(item.numberPackets || item.balance || 0) || 0;
      const q = parseFloat(item.qtval || 0) || 0;

      const totalQty = packets * q;

     const member = members.find(m => m.pharmacyId === item.pharmacyId);
const ocsCode = member?.ocsCode || item.pharmacyId;
const key = `${ocsCode}_${parsed.key}`;



     const price = (parseFloat(item.price || 0)) / 100;  // assuming pence or pounds (see note below)
      const value = packets * price; // total value of packets

      if (!grouped[key]) {
        grouped[key] = {
          pharmacyName: item.pharmacyName,
          pharmacyId: item.pharmacyId,
          snomed: item.snomed,
            ocsCode: ocsCode,
          drugName: item.vmppNm,
          snomed: item.snomed, 
          cleanName: parsed.key,
          qtyOnShelf: 0,
          totalValue: 0 ,
            qtval: item.qtval || 1 
        };
      }

      grouped[key].qtyOnShelf += totalQty;
      grouped[key].totalValue += value;
    });

  // 🔁 BUILD ROWS FIRST
 const rows = Object.values(grouped).map(row => {
  const key = `${row.ocsCode}_${row.cleanName}`;
  const usage = usageNameMap[key] ?? null;

  const pending = pendingTransferMap[key] || 0;

  const adjustedQty = row.qtyOnShelf - pending;

let excess = usage !== null
  ? adjustedQty - (usage * monthsAhead)
  : null;

// 🔥 enforce full-pack logic
if (excess !== null) {
  const packSize = row.qtval || 1;

  const packs = Math.floor(excess / packSize);

  // convert back to tablets (clean multiple)
  excess = packs > 0 ? packs * packSize : 0;
}

  let excessValue = null;

  if (adjustedQty > 0 && excess !== null) {
    const valuePerUnit = row.totalValue / row.qtyOnShelf;
    excessValue = valuePerUnit * excess;
  }

  return {
    ...row,
    usage3m: usage,
    excess,
    excessValue,
    pendingQty: pending,
    adjustedQty
  };
});
  // 🔥 ADD neededByList (SECOND PASS)
  rows.forEach(row => {
    const matches = rows
      .filter(r =>
        r.cleanName === row.cleanName &&
      r.ocsCode !== row.ocsCode &&
        r.excess !== null &&
        r.excess < 0
      )
      .sort((a, b) => a.excess - b.excess); // most negative first

    row.neededByList = matches;
  });

  return rows;

}, [inventoryData, usageNameMap, monthsAhead]);

// 🚚 TRANSFER ENGINE (UNCHANGED)
const suggestions = useMemo(() => {
  const transfers = [];

  const valid = displayData.filter(
    r => r.excess !== null && r.cleanName
  );

  const excessRows = valid.filter(r => r.excess > 0);
  const shortageRows = valid.filter(r => r.excess < 0);

excessRows.forEach(source => {
  let available = source.excess;

  const packSize = source.qtval || 1;

  const matching = shortageRows
    .filter(dest =>
      dest.cleanName === source.cleanName &&
      dest.ocsCode !== source.ocsCode
    )
    .map(dest => {
      const sourceMember = members.find(m => m.ocsCode === source.ocsCode);
      const destMember = members.find(m => m.ocsCode === dest.ocsCode);

      return {
        ...dest,
        distance: getDistance(sourceMember, destMember)
      };
    })
    .sort((a, b) => a.distance - b.distance);

  matching.forEach(dest => {
    if (available <= 0) return;

    const needed = Math.abs(dest.excess);

    // 🔥 max transferable in tablets
    const rawQty = Math.min(available, needed);

    // 🔥 convert to full packs only
    const packs = Math.floor(rawQty / packSize);

    // 🔥 back to tablets (valid multiple)
    const qty = packs * packSize;

    if (packs > 0) {
      transfers.push({
        drug: source.drugName,
        snomed: source.snomed,
        from: source.pharmacyName,
        fromPharmacyId: source.pharmacyId,
        to: dest.pharmacyName,
        toPharmacyId: dest.pharmacyId,
        qty
      });

      available -= qty;
    }
  });

  // 🔥 remaining → warehouse (also full packs only)
  if (available > 0) {
    const packs = Math.floor(available / packSize);
    const qty = packs * packSize;

    if (packs > 0) {
      transfers.push({
        drug: source.drugName,
        snomed: source.snomed,
        from: source.pharmacyName,
        fromPharmacyId: source.pharmacyId,
        to: "Warehouse",
        toPharmacyId: null,
        qty,
        status: "pending"
      });
    }
  }
});
  return transfers;
}, [displayData, members]);
  // 📧 SEND (UNCHANGED)
const sendSuggestion = async (s) => {
  try {
    const token = localStorage.getItem("authToken");

    // 🔎 find the matching row to get pack size
    const row = displayData.find(r =>
      r.pharmacyId === s.fromPharmacyId &&
      r.drugName === s.drug
    );

    if (!row) {
      alert("Could not find stock row");
      return;
    }

    const packSize = row.qtval || 1;

    // 🔥 convert tablets → packs
    const packs = Math.floor(s.qty / packSize);

    if (packs <= 0) {
      alert(`Less than one full pack (${packSize}). Cannot transfer.`);
      return;
    }

    const payload = {
      ...s,
      qty: packs   // ✅ SEND PACKS ONLY
    };

    console.log("🚀 SENDING (PACKS):", payload);

    const res = await fetch("https://api.pharmacegroup.co.uk/sendTransfer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        groupId,
        ...payload
      })
    });

    const result = await res.json();
    console.log("📨 SEND RESULT:", result);

    if (!res.ok) {
      alert("Failed to send transfer");
      return;
    }

    alert(`Sent ${packs} pack(s)`);

    await fetchTransfers();
    await fetchInventory();

  } catch (err) {
    console.log("💥 sendSuggestion error:", err);
    alert("Error sending transfer");
  }
};


// 📥 FETCH TRANSFERS
const fetchTransfers = async () => {
  try {
    const token = localStorage.getItem("authToken");

    const res = await fetch(
      `https://api.pharmacegroup.co.uk/getTransfers?groupId=${groupId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const data = await res.json();


    console.log("📊 TRANSFERS:", data.length);

    setTransferData(data);
  } catch (err) {
    console.log("💥 fetchTransfers error:", err);
  }
};

// 🗑 DELETE
const deleteTransfer = async (id) => {
  try {
    const token = localStorage.getItem("authToken");

    await fetch(
      `https://api.pharmacegroup.co.uk/deleteTransfer/${id}`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    fetchTransfers();
  } catch (err) {
    console.log("💥 deleteTransfer error:", err);
  }
};

// ✅ COMPLETE
const completeTransfer = async (id) => {
  try {
    const token = localStorage.getItem("authToken");

    await fetch(
      `https://api.pharmacegroup.co.uk/completeTransfer/${id}`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    fetchTransfers();
  } catch (err) {
    console.log("💥 completeTransfer error:", err);
  }
};

// 🧾 SEND INVOICE (stub for now)
const sendInvoice = (t) => {
  console.log("📄 SEND INVOICE:", t);
  alert("Invoice function coming next");
};


const formatDateTime = (d) => {
  if (!d) return "";

  const date = new Date(d);

  return (
    date.toLocaleDateString("en-GB") +
    " " +
    date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit"
    })
  );
};


const handleSearchUsage = async () => {
  if (!searchDrug && !searchNhs) {
    alert("Enter a drug name or NHS number");
    return;
  }

  try {
    setSearchLoading(true);

    const token = localStorage.getItem("authToken");

    const res = await fetch("https://api.pharmacegroup.co.uk/searchUsage", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        groupId,
        drug: searchDrug,
        nhs: searchNhs
      })
    });

    const data = await res.json();
    setSearchResults(data || []);
  } catch (err) {
    console.log("💥 search error:", err);
  } finally {
    setSearchLoading(false);
  }
};
// 📅 FORMAT DATE
const formatDate = (d) => {
  if (!d) return "";
  const date = new Date(d);
  return date.toLocaleDateString("en-GB");
};
const handleUpload = async () => {
  if (uploadingUsage) return;

  if (uploadFiles.length === 0) {
    alert("Select file(s)");
    return;
  }
  setUploadingUsage(true);
  try {
    const token = localStorage.getItem("authToken");

    const formData = new FormData();
    uploadFiles.forEach(file => {
      formData.append("files", file);
    });
   
    formData.append("groupId", groupId);

    console.log("📤 Sending files to backend...", uploadFiles.map(f => f.name));

    const res = await fetch("https://api.pharmacegroup.co.uk/uploadUsage", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });

    const result = await res.json();

    console.log("📥 Upload result:", result);

    if (!res.ok) {
      alert(result.error || "Upload failed");
      return;
    }

    alert(
      `Upload complete. Inserted: ${result.inserted || 0}. Skipped files: ${result.skippedFiles || 0}.`
    );

    setUploadFiles([]);
    fetchUsage();
    } catch (err) {
    console.log("💥 upload error:", err);
    alert("Upload error");
  } finally {
    setUploadingUsage(false);
  }
};
const selectedMember = members.find(m => m.pharmacyId === selectedPharmacy);
const selectedOcs = selectedMember?.ocsCode || selectedPharmacy;

const latestMonth = latestUsageMap[selectedOcs];
  const stale = isStale(latestMonth);


const formatDispensingMonth = (val) => {
  if (!val) return "";

  const str = String(val);

  // Extract year (first 4 digits always)
  const year = str.substring(0, 4);

  // Try to extract month (next 2 digits if present)
  let month = str.substring(4, 6);

  // Handle cases like YYYY-M or YYYY-MM or YYYYMM or YYYY/M
  if (!month || isNaN(month)) {
    const match = str.match(/^\d{4}[-\/]?(\d{1,2})/);
    if (match) {
      month = match[1];
    }
  }

  // Ensure 2-digit month
  if (month) {
    month = month.padStart(2, "0");
    return `${month}/${year}`;
  }

  return year; // fallback if no month found
};

  return (
    <div style={{ padding: "20px" }}>
      <h1>Stock Redistribution Engine</h1>

<div style={{ marginBottom: "20px" }}>
  <button onClick={() => { setShowTransfers(true); fetchTransfers(); }}>
    View Transfers
  </button>

  <button
    style={{ marginLeft: "10px" }}
  onClick={() => {
  setSearchResults([]);
  setSearchDrugName("");
  setSearchNhs("");
  setShowSearchDialog(true);
}}
  >
    Search Usage
  </button>
</div>

   <div style={{ marginTop: "20px", marginBottom: "20px", padding: "10px", border: "1px solid #ccc" }}>
  <h3>Upload Usage Data</h3>

  <input
    type="file"
    multiple
    onChange={e => setUploadFiles(Array.from(e.target.files || []))}
  />

<button
  onClick={handleUpload}
  disabled={uploadingUsage}
  style={{ marginLeft: "10px" }}
>
  {uploadingUsage ? "Uploading..." : "Upload"}
</button>

   
</div>

<div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
  <select value={selectedPharmacy} onChange={e => setSelectedPharmacy(e.target.value)}>
    <option value="">All Pharmacies</option>
    {members.map(m => (
      <option key={m.pharmacyId} value={m.pharmacyId}>
        {m.pharmacyName}
      </option>
    ))}
  </select>

  <input
    placeholder="Search drug..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
  />
</div>
      <label style={{ marginLeft: "10px" }}>
        <span style={{ marginLeft: "20px" }}>
  Months ahead to use:
  <select
    value={monthsAhead}
    onChange={e => setMonthsAhead(parseInt(e.target.value))}
    style={{ marginLeft: "5px" }}
  >
    {[...Array(12)].map((_, i) => (
      <option key={i+1} value={i+1}>{i+1}</option>
    ))}
  </select>
</span>

<span style={{ marginLeft: "20px" }}>
  Months usage to average:
  <select
    value={monthsAverage}
    onChange={e => setMonthsAverage(parseInt(e.target.value))}
    style={{ marginLeft: "5px" }}
  >
  {[1,2,3].map((v) => (
  <option key={v} value={v}>{v}</option>
))}
  </select>
</span>
        <input
          type="checkbox"
          checked={onlyExcess}
          onChange={() => setOnlyExcess(!onlyExcess)}
        />
        Show excess only
      </label>
<span style={{ marginLeft: "20px" }}>
  Only show value &gt; £
  <input
    type="number"
    value={minValue}
    onChange={(e) => setMinValue(e.target.value)}
    style={{ width: "80px", marginLeft: "5px" }}
  />
</span>

      <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #ccc", marginTop: "20px" }}>
        <table border="1" cellPadding="6" style={{ width: "100%" }}>
     <thead style={{ position: "sticky", top: 0, background: "#eee" }}>
  <tr>
    <th>Pharmacy</th>
    <th>Drug</th>
    <th>Stock level</th>
    <th>Usage/mth</th>
    <th>Excess</th>
    <th>Excess Value</th>
    <th>Needed By</th>
  </tr>
</thead>

          <tbody>
            {displayData
  .filter(r => {
  if (selectedPharmacy && r.pharmacyId !== selectedPharmacy) return false;

  if (onlyExcess && (!r.excess || r.excess <= 0)) return false;

  if (searchText && !r.drugName.toLowerCase().includes(searchText.toLowerCase())) return false;

  if (minValue && (r.excessValue === null || r.excessValue <= parseFloat(minValue))) return false;

  return true;
})
              .map((row, i) => (
                <tr key={i} style={{ background: row.excess > 0 ? "#d4edda" : "white" }}>
                  <td>{row.pharmacyName}</td>
                  <td>{row.drugName}</td>
              <td>
  {row.adjustedQty.toFixed(0)}
  {row.pendingQty > 0 && (
  <span style={{ color: "#666" }}>
  {" "}({row.pendingQty} tablets pending)
</span>
  )}
</td>
                  <td>{row.usage3m !== null ? row.usage3m.toFixed(1) : "N/A"}</td>
              <td>{row.excess !== null ? row.excess.toFixed(1) : "-"}</td>

<td>
  {row.excessValue !== null
    ? `£${row.excessValue.toFixed(2)}`
    : "-"}
</td>

<td>
  {row.neededByList && row.neededByList.length > 0 ? (
    <span
      style={{ cursor: "pointer", color: "blue" }}
      onClick={() => setNeededDialog(row)}
    >
      {row.neededByList
        .slice(0, 2)
        .map(r => r.pharmacyName)
        .join(", ")}
      {row.neededByList.length > 2 && "..."}
    </span>
  ) : "-"}
</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <h2 style={{ marginTop: "30px" }}>Transfer Suggestions</h2>

      <div style={{ maxHeight: "250px", overflowY: "auto", border: "1px solid #ccc" }}>
        <table border="1" cellPadding="6" style={{ width: "100%" }}>
          <thead style={{ position: "sticky", top: 0, background: "#eee" }}>
            <tr>
              <th>Drug</th>
              <th>From</th>
              <th>To</th>
              <th>Qty</th>
              <th>Send</th>
            </tr>
          </thead>

          <tbody>
            {suggestions.map((s, i) => (
              <tr key={i}>
                <td>{s.drug}</td>
                <td>{s.from}</td>
                <td>{s.to}</td>
                <td>{s.qty}</td>
                 <td>
                  <button onClick={() => sendSuggestion(s)}>
                    Send
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

{showTransfers && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      zIndex: 1000
    }}
  >
    <div
      style={{
        background: "white",
        margin: "5% auto",
        padding: "20px",
        width: "90%",
        maxHeight: "80%",
        overflow: "auto"
      }}
    >
      <h2>Transfers</h2>

      <button onClick={() => setShowTransfers(false)}>Close</button>

      <table border="1" cellPadding="6" style={{ width: "100%", marginTop: "10px" }}>
        <thead>
          <tr>
            <th>Date</th>
            <th>From</th>
            <th>To</th>
            <th>Items</th>
            <th>Picked</th>
            <th>Received</th>
            <th>Completed</th>
            <th>Invoice Sent</th>
            <th>Deleted</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {transferData.map((t, i) => (
            <tr key={i}>
              {/* ✅ CREATED DATE + TIME */}
              <td>{formatDateTime(t.createdAt)}</td>

              <td>{t.fromPharmacyName}</td>
              <td>{t.toPharmacyName}</td>

              <td>
                {t.items?.map((it, idx) => (
                  <div key={idx}>
                    {it.drug} ({it.qty})
                  </div>
                ))}
              </td>

              {/* ✅ PICKED */}
              <td>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setExpandedPicked(prev => ({
                      ...prev,
                      [t._id]: !prev[t._id]
                    }))
                  }
                >
                  📦 {t.picked?.length || 0}
                </span>

                {expandedPicked[t._id] && (
                  <div style={{ marginTop: "5px" }}>
                    {t.picked?.map((p, idx) => (
                      <div key={idx}>
                        {p.drug} ({p.qty}){" "}
                        {p.timestamp && (
                          <span style={{ color: "#666" }}>
                            - {formatDateTime(p.timestamp)}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </td>

              {/* ✅ RECEIVED */}
              <td>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setExpandedReceived(prev => ({
                      ...prev,
                      [t._id]: !prev[t._id]
                    }))
                  }
                >
                  📥 {t.received?.length || 0}
                </span>

                {expandedReceived[t._id] && (
                  <div style={{ marginTop: "5px" }}>
                    {t.received?.map((r, idx) => (
                      <div key={idx}>
                        {r.drug} ({r.qty}){" "}
                        {r.timestamp && (
                          <span style={{ color: "#666" }}>
                            - {formatDateTime(r.timestamp)}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </td>

              {/* ✅ COMPLETED WITH TIME */}
              <td>
                {t.status === "completed"
                  ? `✅ ${formatDateTime(t.completedAt)}`
                  : "❌"}
              </td>

              {/* ✅ INVOICE SENT WITH TIME */}
              <td>
                {t.invoiceSent
                  ? `✅ ${formatDateTime(t.invoiceSentAt)}`
                  : "❌"}
              </td>

              {/* ✅ DELETED WITH TIME */}
              <td>
                {t.deleted
                  ? `✅ ${formatDateTime(t.deletedAt)}`
                  : "❌"}
              </td>

              <td>
                <button onClick={() => completeTransfer(t._id)}>Complete</button>
                <button onClick={() => deleteTransfer(t._id)}>Delete</button>
                <button onClick={() => sendInvoice(t)}>Send Invoice</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}


{showSearchDialog && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      zIndex: 3000
    }}
  >
    <div
      style={{
        background: "white",
        margin: "5% auto",
        padding: "20px",
        width: "700px",
        maxHeight: "80%",
        overflow: "auto"
      }}
    >
      <h2>Search Usage</h2>

  <div style={{ marginBottom: "10px" }}>
  <input
    placeholder="Enter drug name to search for"
    value={searchDrug}
    onChange={(e) => setSearchDrug(e.target.value)}
    style={{ marginRight: "10px" }}
  />

  <input
    placeholder="Last 7 digits NHS number"
    value={searchNhs}
    onChange={(e) => {
      const digitsOnly = e.target.value.replace(/\D/g, "");
      setSearchNhs(digitsOnly);
    }}
    maxLength={7}
  />

  <button onClick={handleSearchUsage} disabled={searchLoading} style={{ marginLeft: "10px" }}>
    {searchLoading ? "Searching..." : "Search"}
  </button>
</div>
      <table border="1" cellPadding="6" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>OCS Code</th>
            <th>Month</th>
            <th>Drug</th>
            <th>Qty</th>
            <th>NHS Fragment</th>
          </tr>
        </thead>
        <tbody>
          {searchResults.map((r, i) => (
            <tr key={i}>
              <td>{r.ocsCode}</td>
 <td>{formatDispensingMonth(r.dispensingmonth)}</td>
              <td>{r.drugname}</td>
              <td>{r.qty_used}</td>
              <td>{r.nhsNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <button
        onClick={() => setShowSearchDialog(false)}
        style={{ marginTop: "10px" }}
      >
        Close
      </button>
    </div>
  </div>
)}


{neededDialog && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      zIndex: 2000
    }}
  >
    <div
      style={{
        background: "white",
        margin: "5% auto",
        padding: "20px",
        width: "500px",
        maxHeight: "70%",
        overflow: "auto"
      }}
    >
      <h3>Needed By</h3>

      <p><b>{neededDialog.drugName}</b></p>

      {neededDialog.neededByList && neededDialog.neededByList.length > 0 ? (
        neededDialog.neededByList.map((r, i) => (
          <div key={i} style={{ marginBottom: "6px" }}>
            {r.pharmacyName} — needs {Math.abs(r.excess).toFixed(0)}
          </div>
        ))
      ) : (
        <div>No shortages found</div>
      )}

      <button
        onClick={() => setNeededDialog(null)}
        style={{ marginTop: "15px" }}
      >
        Close
      </button>
    </div>
  </div>
)}





    </div>
  );
};

export default StockExcess;